var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6079 18.3497C13.6785 18.3499 17.1832 15.4765 17.9809 11.4848C18.7786 7.49316 16.6474 3.49346 12.8893 1.92924C9.13129 0.365026 4.79159 1.67135 2.52147 5.05015C0.251351 8.42895 0.682202 12.9405 3.55081 15.8285C5.15349 17.4421 7.33368 18.3495 9.6079 18.3497Z",
    stroke: "#2E75FF",
    strokeWidth: 1.8975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-21",
    d: "M9.01953 6.08575V10.2474H13.0043",
    stroke: "#2E75FF",
    strokeWidth: 1.8975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueue);
export default __webpack_public_path__ + "static/media/queue.4bbf7ec598bde98f4d953a4e32fa05ae.svg";
export { ForwardRef as ReactComponent };